<div class="border p-2">
    <div class="label pl-2">
        <label>{{ config.label }}</label>
    </div>
    <div class="d-inline-flex pl-2">
        <mat-radio-group ngDefaultControl [formControl]="controle" style="padding-right: 4em;">
            <mat-radio-button class="mr-2"
                              *ngFor="let optionValue of config.values"
                              [value]="optionValue.value"
                              [disabled]="disabled"
                              (change)="atualizaControle($event)">
                {{ optionValue.text }}
            </mat-radio-button>
        </mat-radio-group>
    </div>
</div>

